import React from "react";

function GreenCheckCircle() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="20"
                height="20"
                rx="10"
                fill="#2EA957"
                fillOpacity="0.15"
            />
            <path
                d="M14.6668 6.5L8.25016 12.9167L5.3335 10"
                stroke="#2EA957"
                strokeWidth="1.16667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default GreenCheckCircle;
